import React from 'react';
import { Box, Typography } from '@mui/material';

const Dataset = () => {
    return (
        <Box sx={{ p: 4 }}>
            <Typography variant="h4" gutterBottom sx={{ color: '#40685E', fontWeight: 'bold' }}>
                Tela Dataset
            </Typography>
            <Typography variant="body1">
                Esta é uma tela placeholder para o desenvolvimento futuro da seção Dataset.
            </Typography>
        </Box>
    );
};

export default Dataset;